export default {
  title: 'Bankverbindung',
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    success: 'Ihre Informationen wurden erfolgreich gespeichert.',
  },
};
